/* eslint prefer-template:0 */

import joinURL from '../common/joinURL.js'

export default function miniPackages(window, requirejs, isServerSide) {
  const { document, location = {} } = window

  function enableLink() {
    this.removeAttribute('media')
  }

  function appendCss(url, id) {
    const link = document.createElement('link')
    link.setAttribute('rel', 'stylesheet')
    link.setAttribute('href', url)
    link.setAttribute('media', 'none')
    link.setAttribute('id', 'font_' + id)
    link.addEventListener('load', enableLink, false)
    document.head.appendChild(link)
  }

  if (!document.querySelector('link[href$="viewer.css"]')) {
    appendCss(joinURL(window.santaBase, 'static/css/viewer.css'), 'viewer')
  }

  // Prefetch font CSS files
  // By marking them as media="none" their download is made non-blocking
  // (At least for WebKit / Blink browsers)
  // (WixThemeReact may remove this attribute)
  requirejs(['lodash', 'fonts'], (_, fonts) => {
    if (!isServerSide && location.hostname !== 'localhost') {
      const cssUrls = fonts.fontUtils.getCssUrls(window.rendererModel.siteInfo.documentType, window.serviceTopology)
      _.forEach(cssUrls, appendCss)
    }
  })
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/miniPackages.js